import { jsx as _jsx } from "react/jsx-runtime";
import { v4 as uuid } from 'uuid';
import styles from './TextHighlight.module.scss';
import { queryString, queryEscapedString } from './utils';
import cx from 'classnames';
export const TextHighlight = ({ text = '', textToHighlight = '', highlightClassName, isEscape, isVirtualScroll = false, isSpecialCharacters = false }) => {
    let regex;
    if (isEscape) {
        regex = new RegExp(`(${queryString(textToHighlight)})`, 'gi');
    }
    else {
        regex = isSpecialCharacters
            ? new RegExp(`(${queryEscapedString(textToHighlight)})`, 'gi')
            : new RegExp(`(${textToHighlight})`, 'gi');
    }
    const parts = text.split(regex);
    if (!textToHighlight.trim()) {
        return (_jsx("span", { className: cx(highlightClassName, styles['highlight-text']), children: text }, uuid()));
    }
    return (_jsx("span", { className: cx(styles['highlight-text'], {
            [`${highlightClassName}`]: isVirtualScroll
        }), children: parts
            .filter((part) => part)
            .map((part) => regex.test(part) ? (_jsx("span", { className: cx(styles['highlight']), children: part }, uuid())) : (_jsx("span", { children: part }, uuid()))) }));
};
